<template>
    <div>
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <cohorts-crud></cohorts-crud>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CohortsCrud from './cohorts/CohortsCrud';

    export default {

        components: {
            CohortsCrud
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('common.cohorts'),
                    },
                ]
            }
        },
    }
</script>
